module.exports = __webpack_public_path__ + "img/macherIN.2cbcdb5c.jpeg";